import { createContext } from 'react'

const defaultValue = {
  companyId: 1,
  company: {}
}

const RabbitContext = createContext(defaultValue)
export default RabbitContext
